export default __webpack_public_path__ + "static/media/key_features_construction_sites.fe6e3c11.png";